/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
// import range from 'lodash/range';
import classNames from 'classnames';

import './Spinner.scss';

/**
 * This is the Spinner component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Spinner({ title, className, ...rest }) {
  return (
    <div
      className={classNames('spinner', className)}
      aria-label={title}
      {...rest}
    >
      <div>
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Spinner.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Spinner.defaultProps = {
  title: 'Loading',
  className: null,
};

export default Spinner;
